import { defineRouting } from 'next-intl/routing';

import {
  DEFAULT_LOCALE,
  pathnames,
  SUPPORTED_LOCALES
} from './localizedRoutes';

export const routing = defineRouting({
  locales: SUPPORTED_LOCALES,
  defaultLocale: DEFAULT_LOCALE,
  pathnames
});
